module.exports = __webpack_public_path__ + "img/logo-nti.2c10fa44.png";